import Vue from 'vue';
import dateFilter from './../mixins/dateFilter.js'
import EventHub from './eventHub.js'


export default new Vue({
    mixins: [dateFilter],
    data: function () {
        return {
            filters: {
                catalog: {
                    open: true,
                    selected: [],
                    field: 'search_catalog'
                },
                media: {
                    open: false,
                    selected: [],
                    field: 'searchable-has_media-keyword'
                },
                type: {
                    open: false,
                    selected: [],
                    field: 'searchable-types-keyword'
                },
                language: {
                    open: false,
                    selected: [],
                    field: 'searchable-languages-keyword'
                },
                place: {
                    open: false,
                    selected: [],
                    field: 'searchable-places-keyword'
                },
                exhibits: {
                    open: false,
                    selected: [],
                    field: 'searchable-exhibits-keyword'
                },
                search: {
                    selected: [],
                    field: 'query',
                    single_select: true
                },
                date: {
                    open: false,
                    selected: [],
                    to_year: null,
                    from_year: null,
                    to_era: 'AD/CE',
                    from_era: 'AD/CE',
                    field: 'date',
                    single_select: true,
                    exclude_from_query: true,
                    clear: function () {
                        this.to_year = null
                        this.from_year = null
                    }
                },
                // This has purposefully different name
                // then the query param. This prevents advanced query
                // param from automatically appearing as filter.
                advanced_search: {
                    selected: [],
                    field: 'advanced_search',
                    query: [],
                    single_select: true,
                    exclude_from_query: true,
                    clear: function () {
                        this.query = []
                    }
                },
                vessel_type: {
                    selected: [],
                    field: 'searchable-vessel_type-keyword'
                },
                actors: {
                    selected: [],
                    field: 'searchable-actors-keyword'
                },
                topics: {
                    selected: [],
                    field: 'searchable-topics-keyword'
                },
                terms: {
                    selected: [],
                    field: 'searchable-terms-keyword'
                },
                genre: {
                    selected: [],
                    field: 'searchable-genre-keyword'
                },
                materials: {
                    selected: [],
                    field: 'searchable-materials-keyword'
                },
                related: {
                    selected: [],
                    field: 'related',
                    child_field: 'child-keyword',
                    parent_field: 'parent-keyword',
                    indices: null,
                    child: null,
                    parent: null,
                    single_select: true,
                    exclude_from_query: true,
                    clear: function () {
                        this.child = null
                        this.parent = null
                        this.indices = null
                    }
                }
            }
        }
    },
    methods: {
        addByField: function (field, value) {
            var found = false

            if (value == '') {
                return
            }

            for (var name in this.filters) {
                if (this.filters[name].field == field) {

                    // If only one value can be selected at a time remove all values before adding new
                    if (this.filters[name].single_select) {
                        this.filters[name].selected = []
                    }

                    // Ignore if a duplicate
                    if (this.filters[name].selected.indexOf(value) == -1) {
                        this.filters[name].selected.push(value)
                        found = true
                    }
                }
            }
        },
        addByQuery: function (query) {
            var has_advanced = query.hasOwnProperty('advanced')
            var has_date = query.hasOwnProperty('to_year') || query.hasOwnProperty('from_year')
            var has_related = query.hasOwnProperty(this.filters.related.parent_field) ||
                query.hasOwnProperty(this.filters.related.child_field)

            // Process date filter first
            if (has_date) {
                var date_filter = this.formatDateFilter(
                    query.from_year,
                    query.from_era,
                    query.to_year,
                    query.to_era
                )

                this.addByField('date', date_filter.selected)
            }

            if (has_related) {
                var child = query[this.filters.related.child_field]
                var parent = query[this.filters.related.parent_field]

                this.filters.related.indices = query.indices ? query.indices : null
                this.filters.related.child = child
                this.filters.related.parent = parent
                this.addByField('related', this.formatRelated(query.indices, child ? child : parent))
            }

            if (has_advanced) {
                this.filters.advanced_search.query = query.advanced
                this.addByField('advanced_search', 'Advanced Search')
            }

            // Process all other filters
            for (var key in query) {
                var query_values = Array.isArray(query[key]) ? query[key] : [query[key]]
                for (var value in query_values) {
                    this.addByField(key, query_values[value])
                }
            }
        },
        removeByField: function (field, value = []) {
            // Find the filter with the correct field
            for (var name in this.filters) {
                if (this.filters[name].field == field) {
                    if (name == 'related') {
                        this.filters.related.child = null
                        this.filters.related.parent = null
                        this.filters.related.indices = null
                        this.filters.related.selected = []
                    }
                    if (name == 'date') {
                        this.filters.date.from_year = null
                        this.filters.date.to_year = null
                        this.filters.date.selected = []
                    } else if (name == 'advanced_search') {
                        this.filters.advanced_search.query = null
                        this.filters.advanced_search.selected = []
                    } else {
                        // splice out the value given
                        var index = _.indexOf(this.filters[name].selected, value)
                        this.filters[name].selected.splice(index, 1)
                    }
                }
            }

            EventHub.$emit('filter-results')
        },
        clearFilter: function (name) {
            this.filters[name].selected = []

            if (this.filters[name].clear) {
                this.filters[name].clear()
            }
        },
        clearAll: function () {
            for (var name in this.filters) {
                this.clearFilter(name)
            }
        },
        selectDateFilter: function () {
            var date_filter = this.formatDateFilter(
                this.filters.date.from_year,
                this.filters.date.from_era,
                this.filters.date.to_year,
                this.filters.date.to_era
            )

            if (date_filter.selected) {
                this.addByField('date', date_filter.selected)
                return date_filter.query
            }

            return {}
        },
        selectRelatedFilter: function (query) {
            var indices = this.filters.related.indices
            var child = this.filters.related.child
            var parent = this.filters.related.parent

            if (child || parent) {
                var selected = this.formatRelated(indices, child ? child : parent)
                if (child) {
                    query[this.filters.related.child_field] = child
                } else {
                    query[this.filters.related.parent_field] = parent
                }

                if (indices) {
                    query['indices'] = indices
                }

                this.addByField('related', selected)
            }

            return query
        },
        formatRelated: function (indices, id) {
            if (!indices) {
                return 'All Related Records'
            }

            indices = Array.isArray(indices) ? indices : [indices]
            var list = []

            for (var index of indices) {
                var record_type = ''

                switch (index) {
                    case 'archival_collection':
                        record_type = 'Archival Collections'; break;
                    case 'archival_series':
                        record_type = 'Archival Series'; break;
                    case 'archival_fileunit':
                        record_type = 'Archival File Units'; break;
                    case 'archival_item':
                        record_type = 'Archival Items'; break;
                    case 'library':
                        record_type = 'Library Records'; break;
                    case 'vessel':
                        record_type = 'Vessels'; break;
                    case 'association':
                        record_type = 'Associations'; break;
                    case 'exhibit':
                        record_type = 'Exhibits'; break;
                    default:
                        record_type = 'Items'
                }

                if (list.indexOf(record_type) == -1) {
                    list.push(record_type)
                }
            }

            return 'Related ' + list.join(' & ')
        },
        formattedForDisplay: function () {
            var merged = []
            for (var name in this.filters) {
                var filter = this.filters[name]

                if (!filter.hide && filter.selected !== 'undefined') {
                    for (var i in filter.selected) {
                        merged.push({
                            field: filter.field,
                            value: filter.selected[i]
                        })
                    }
                }
            }

            return merged
        },
        generateQuery: function () {
            // Add date query manually
            var query = this.selectDateFilter()
            // Add related manually
            query = this.selectRelatedFilter(query)

            // Add advanced query manually
            if (this.filters.advanced_search.query && this.filters.advanced_search.query.length > 0) {
                query.advanced = this.filters.advanced_search.query
            }

            // loop over each selected filter and store them for route query
            for (var name in this.filters) {
                if (!this.filters[name].exclude_from_query && this.filters[name].selected.length) {
                    query[this.filters[name].field] = this.filters[name].selected
                }
            }

            return query
        },
        toggleOpen: function (name) {
            for (var filter_name in this.filters) {
                if (filter_name == name) {
                    this.filters[filter_name].open = !this.filters[filter_name].open
                } else {
                    this.filters[filter_name].open = false
                }
            }
        },
        checkYear: function (check) {
            var to = this.filters.date.to_year
            var from = this.filters.date.from_year
            console.log(to, from)
            if (check && !to) {
                this.filters.date.to_year = to ? to : from
            }
            if(!check && !from){
                this.filters.date.from_year = from ? from : to
            }
            return true;
        },
        cleanHtml: function (value) {
            return value.replace(/&ndash;/gi, "-")
        }
    }
})
